import { computed, toValue } from 'vue';

import type { MaybeRefOrGetter } from 'vue';

export function reactiveOption<T>(
  source: MaybeRefOrGetter<T | undefined>,
  defaultValue?: T
) {
  return computed(() => {
    const resolved = toValue(source);
    return resolved ?? defaultValue;
  });
}
